export default __webpack_public_path__ + "static/media/actividad-31.8b5f0873.mp3";